import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M26.36,9.45,20.7,3.84a.64.64,0,0,0-.45-.19H8.3A2.82,2.82,0,0,0,5.45,6.43V25.57A2.82,2.82,0,0,0,8.3,28.35H23.7a2.82,2.82,0,0,0,2.85-2.78V9.91A.64.64,0,0,0,26.36,9.45ZM20.25,5.22,25,10H22.29a2,2,0,0,1-2-1.85ZM23.7,27.05H8.3a1.52,1.52,0,0,1-1.55-1.48V6.43A1.52,1.52,0,0,1,8.3,5H19V8.1a3.25,3.25,0,0,0,3.34,3.15h3V25.57A1.52,1.52,0,0,1,23.7,27.05Z' }),
  React.createElement('rect', { x: '9.7', y: '12.65', width: '5.4', height: '1.3' }),
  React.createElement('rect', { x: '9.7', y: '17.15', width: '12.6', height: '1.3' }),
  React.createElement('rect', { x: '9.7', y: '21.65', width: '12.6', height: '1.3' })
));